export default "__VITE_ASSET__qycp_6yc__"